import { Table, Spin, Empty } from 'antd';
import { useWidgetData } from '@hooks/useWidgetData';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

interface Config {
  pageSize?: number;
  dataSet?: string;
  xColumn?: string;
  yColumn?: string;
}

function TableWidget({ instance }: WidgetRenderProps<Config>) {
  const { data, isLoading } = useWidgetData<Record<string, unknown>[]>(
    instance.id,
    'table',
    instance.config as Record<string, unknown>,
    instance.refreshInterval,
  );
  if (isLoading) return <Spin />;
  if (!data || data.length === 0) return <Empty />;

  const columns = Object.keys(data[0]).map((key) => ({
    title: key,
    dataIndex: key,
    key,
    ellipsis: true,
  }));

  return (
    <Table
      size="small"
      rowKey="id"
      columns={columns}
      dataSource={data}
      pagination={{ pageSize: instance.config.pageSize ?? 10, size: 'small' }}
      scroll={{ y: 'calc(100% - 60px)' }}
    />
  );
}

export const tableWidgetDef: WidgetDefinition<Config> = {
  type: 'table',
  name: 'Table',
  description: 'Tabular data',
  icon: 'TableOutlined',
  category: 'data',
  defaultTitle: 'Table',
  defaultConfig: { pageSize: 10 },
  minW: 4,
  minH: 4,
  defaultW: 8,
  defaultH: 6,
  component: TableWidget,
  settingsSchema: { fields: [{ key: 'pageSize', label: 'Rows per page', type: 'number' }] },
};
